// plural(3, 'item') -> "3 items"
export const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`;
